import sanitize from 'sanitize-html'

export const removeAllTags = (text?: string) =>
  sanitize(text || '', {
    textFilter: (t) =>
      `${t}\n`.replaceAll(/https:\/\/www.youtube.com\/watch\?v=\w+/g, ''),
    allowedTags: [],
  })

export const sanitizeHTML = (html: string) =>
  sanitize(html, {
    allowedTags: [
      'p',
      'span',
      'figure',
      'img',
      'a',
      'div',
      'h1',
      'h2',
      'h3',
      'h4',
      'strong',
      'em',
      'u',
      'embed',
      'iframe',
    ],
    allowedClasses: {
      a: ['buv-embed-link'],
      figure: ['buv-embed-image'],
      div: [
        'embed-link-left',
        'embed-link-right',
        'embed-link-left-title',
        'embed-link-left-sitename',
        'embed-link-left-description',
        'buv-embed-link-href',
        'buv-embed-link-container',
        'buv-embed-image-caption',
        'buv-embed-embed',
        'buv-embed-embed-container',
        'buv-embed-iframe-container',
      ],
    },
    allowedAttributes: {
      figure: ['data-alt', 'data-src', 'data-caption'],
      img: ['alt', 'src'],
      a: [
        'alt',
        'href',
        'target',
        'data-site-name',
        'data-image',
        'data-title',
      ],
      embed: ['src'],
      iframe: ['src', 'allow', 'width', 'height', 'scrolling', 'frameborder'],
      p: ['class'],
      span: ['style'],
      em: ['style'],
      u: ['style'],
      strong: ['style'],
      h2: ['style'],
      h3: ['style'],
      h4: ['style'],
    },
    allowedIframeHostnames: ['w.soundcloud.com'],
    allowedSchemes: ['data', 'http', 'https'],
  })
